//  Audio Actions
export const SELECT = "SELECT";
export const PLAY_OR_PAUSE = "PLAY_OR_PAUSE";
export const SET_TIME = "SET_TIME";
export const AUDIO_ENDED = "AUDIO_ENDED";
export const MUTE_UNMUTE = "MUTE_UNMUTE";
export const NEXT = "NEXT";
export const PREV = "PREV";
export const VOLUME_CHANGE = "VOLUME_CHANGE";
export const PLAY = "PLAY";

// Audio modes
export const SHUFFLE = "SHUFFLE";
export const REPEAT = "REPEAT";
export const REPEAT_1 = "REPEAT_1";
export const LINEAR = "LINEAR";

// Que
export const ADD_TO_QUE = "ADD_TO_QUE";
export const CLEAR_QUE = "CLEAR_QUE";

// Playlist actions
export const ADD_TO_PLAYLIST = "ADD_TO_PLAYLIST";
export const GET_PLAYLISTS = "GET_PLAYLISTS";
export const GET_MY_PLAYLISTS = "GET_MY_PLAYLISTS";
export const CREATE_PLAYLIST_TITLE = "CREATE_PLAYLIST_TITLE";
export const DELETE_PLAYLIST = "DELETE_PLAYLIST";
export const PLAY_PLAYLIST = "PLAY_PLAYLIST";

// Track
export const LIKE_UNLIKE = "LIKE_UNLIKE";
export const SELECTED_TRACK = "SELECTED_TRACK";

// Alerts
export const SET_ALERT = "SET_ALERT";
export const REMOVE_ALERT = "REMOVE_ALERT";

// Misc
export const TO_ADD = "TO_ADD";
export const SONG = "SONG";
export const PLAYLIST = "PLAYLIST";
export const RESET_SELECTED = "RESET_SELECTED";
export const RESET_LOADING = "RESET_LOADING";
export const SET_LOADING = "SET_LOADING";
export const LOAD_USER_PROFILE = "LOAD_USER_PROFILE";
export const FAN_ME = "FAN_ME";
export const SET_USER_TRACKS = "SET_USER_TRACKS";
export const SET_THEME = "SET_THEME";
export const SET_PRINT = "SET_PRINT";

// Data
export const LOAD_DATA = "LOAD_DATA";
export const LOAD_ALBUMS = "LOAD_ALBUMS";
export const LOAD_USERS = "LOAD_USERS";
export const GET_DATA = "GET_DATA";
export const LOAD_USER_ALBUMS = "LOAD_USER_ALBUMS";
export const UPLOAD_PROGRESS = "UPLOAD_PROGRESS";

// Auth
export const LOGIN = "LOGIN";
export const REGISTER = "REGISTER";
export const AUTH_ERROR = "AUTH_ERROR";
export const LOGOUT = "LOGOUT";
